import angular from 'angular';
import CompanyService from './company.service';

let companyModule = angular.module('company', [
])
.service('CompanyService', CompanyService);

export default companyModule;



// WEBPACK FOOTER //
// ./client/common/services/company/company.js